import React, { Fragment } from 'react'
import {Row, Col, Form } from 'react-bootstrap'

import InfoIconOverlay from './InfoIconOverlay'

// working with numerous fields requires the passing of all of the parent component's props to this component

// options should be an array of objects that are structured as such:
// {
//   value: 'Metastatic Solid Tumor',
//   textFields: [
//      {
//        displayName: 'Metastatic Tumor Primary Site',
//        fieldName: 'metastaticTumorPrimarySite'
//      },
//      {displayName: 'Metastatic Tumor Metastatic Site(s)',
//      fieldName: 'metastaticTumorMetastaticSites'
//    },
//   ]
// }

// the textFields key is only required if the option, when selected, requires optional text fields

//the checkFields key is only required if the option, when selected, required checkFields. If this is the case, a nestedLabel is also only required if you want an additional question label for those nested checks, as well as a nestedName that corresponds to the var in reducer holding this value.


const SelectWithOptionalTextField = (props) => {
  const {
    label,
    options,
    selectFieldName,
    selected,
    handleChange,
    handleSelect,
    onBlur,
    disabled,
    infoText,
    placeholder,
    required,
    className
  } = props

  const selectedOption = props.options.find(option => option.value === selected)

  return (
    <div>
      <Row style={{paddingBottom: "0"}}>
        <Col xs={12} sm={12} md={6} lg={6}>
          <Form.Label>
            {label}

            {infoText ?
              <InfoIconOverlay text={infoText} />
              :
              null
            }
          </Form.Label>
        </Col>
      </Row>

      <Row style={{paddingTop: "0", marginBottom: "1rem"}}>
        <Col xs={12} sm={12} md={6} lg={6}>
          <Form.Control
            as="select"
            className={className || null}
            name={selectFieldName}
            value={selected}
            onChange={handleChange}
            onBlur={onBlur}
            disabled={disabled}
            required={required}
          >
          <option value="">{placeholder || "Please make a selection"}</option>
          {options.map((option, index) => {
            return (
              <option
                key={`${option.value} ${index}`}
                value={option.value}
              >
                {option.value}
              </option>
            )
          })}
         </Form.Control>
        </Col>
      </Row>

      {selectedOption && selectedOption.textFields && selectedOption.textFields.length > 0 ?
        <Fragment>
          <br/>
          {selectedOption.textFields.map((textField, index) => {
            return (
              <Row key={`${textField.fieldName} ${index}`} style={{marginBottom: '10px'}}>

                <Col xs={2} sm={2} md={1} lg={1}>
                </Col>

                <Col xs={10} sm={10} md={6} lg={6}>
                  <Form.Label>
                    {textField.displayName}
                  </Form.Label>

                  <Form.Control
                    name={textField.fieldName}
                    value={props[textField.fieldName]}
                    onChange={handleChange}
                    placeholder={textField.displayName}
                    onBlur={onBlur}
                    disabled={disabled}
                    required={required}
                  />
                </Col>
              </Row>
            )
          })}
        </Fragment>
        :
        null
      }

      {
        selectedOption && selectedOption.checkFields && selectedOption.checkFields.length > 0
        ?
          <div className="indented-row">
            <Form.Label>
              {selectedOption.nestedCheckLabel}
            </Form.Label>
            {selectedOption.checkFields.map(checkField => {
              const nestedOptionIsSelected = props[checkField.fieldName] === true

              return (
                <Form.Check
                  name={selectedOption.fieldName}
                  label={selectedOption.displayName}
                  value={nestedOptionIsSelected}
                  checked={nestedOptionIsSelected}
                  onChange={(e) => handleSelect(e.target.name, !nestedOptionIsSelected)}
                  disabled={disabled}
                  required={required}
                />
              )
            })}
          </div>
        :
          null
      }

      {selectedOption && selectedOption.selectFields && selectedOption.selectFields.length ?
        <Fragment>
          <br/>
          {selectedOption.selectFields.map(nestedSelectField => {
            return (
              <Row key={nestedSelectField.fieldName}>
                <Col xs={2} sm={2} md={1} lg={1}>
                </Col>

                <Col xs={10} sm={10} md={6} lg={6}>
                  <Form.Label>
                    {nestedSelectField.displayName}
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name={nestedSelectField.fieldName}
                    value={props[nestedSelectField.fieldName]}
                    onChange={handleChange}
                    onBlur={onBlur}
                    disabled={disabled}
                    required={required}
                  >
                    <option value="">{placeholder || "Please make a selection"}</option>
                    {nestedSelectField.options.map(option => {
                      return (
                        <option
                          key={option.value}
                          value={option.value}
                        >
                          {option.value}
                        </option>
                      )
                    })}
                 </Form.Control>
               </Col>
             </Row>
            )
          })}
        </Fragment>
        :
        null
      }
    </div>
  )
}


SelectWithOptionalTextField.defaultProps = {
  onBlur: () => null,
}

export default SelectWithOptionalTextField
